module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sylvain Alzial, Hélène Rajcak\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('I', [_c('B', [_vm._v("Sylvain Alzial")]), _vm._v(" was born in Monaco. He has been writing children's books since 2013 and makes his English language debut with "), _c('I', [_vm._v("Panthera Tigris"), _c('I', [_vm._v(". When he's not writing, Sylvain produces documentaries and programs on world music for Radio France. He lives in Paris.")])], 1)], 1), _c('BR'), _c('BR'), _c('B', [_vm._v("Hélène Rajcak")]), _vm._v(" studied illustration at the National School of Decorative Arts in Paris. She also has a background in engraving and textile design. Her previous books include "), _c('I', [_vm._v("Small and Tall Tales of Extinct Animals")]), _vm._v(" (Lerner). She lives in Paris.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1B4sM57/tc-custom/9781467457750.jpg?1709697360063",
      "alt": "This image is the cover for the book Panthera Tigris"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Panthera Tigris\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("While reading an encyclopedia, a highly educated scientist realizes that he doesn’t know anything about tigers! He begins studying them until he can rattle off every tiger fact imaginable, including their habitat (jungles and marshy areas), their average weight (300-500 pounds), and their scientific name (Panthera tigris). But when he hires a guide to take him to see a tiger in person, the scientist discovers that he might not quite know everything.")]), _c('p', [_vm._v("With deadpan humor and illustrations that perfectly complement the story, Panthera Tigris will delight nature lovers and budding scientists.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0